import React, { useState } from 'react'
import "./Contact.css"
import emailjs from "@emailjs/browser";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  // Handle Input Change
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  // Validation
  const validateForm = () => {
    let newErrors = {};

    // Name Validation
    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }

    // Email Validation
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    ) {
      newErrors.email = "Invalid email address";
    }

    // Subject Validation
    if (!formData.subject.trim()) {
      newErrors.subject = "Subject is required";
    }

    // Message Validation
    if (!formData.message.trim()) {
      newErrors.message = "Message is required";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  // Submit Form
  const handleSubmit = (e) => {
    e.preventDefault();

    // Check Validation
    if (!validateForm()) return;

    // Send Email
    emailjs
      .send(
        "service_rlhvi6n", // Replace with EmailJS Service ID
        "template_2zin06s", // Replace with EmailJS Template ID
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
        },
        "850TjuzrHmUv8mJxb" // Replace with EmailJS Public Key
      )
      .then(
        (result) => {
          console.log(result.text);

          setSuccessMessage("Message Sent Successfully!");

           setTimeout(() => {
          setSuccessMessage("");
        }, 3000);


          // Reset Form
          setFormData({
            name: "",
            email: "",
            subject: "",
            message: "",
          });

          setErrors({});
        },
        (error) => {
          console.log(error.text);
          alert("Something went wrong!");
        }
      );
  };
  return (
    <>
      <div className="contact-wrapper">
        {/* Page Header/Banner */}
        <section className="section-padding banner_sec contact-banner">
          <div className="container text-center">
            <div className="banner-wraper">
              <h1 className="banner-heading">Get in <span>Touch</span></h1>
              <p className="banner-sub-heading">We are here to help and answer any questions you might have.</p>
            </div>
          </div>
        </section>

        {/* Contact Info & Form Section */}
        <section className="section-padding bg-color">
          <div className="container">
            <div className="row">

              {/* Left Side: Contact Information */}
              <div className="col-lg-5">
                <div className="contact-info-card">
                  <span className="top-heading">CONTACT US</span>
                  <h2 className="heading mb-4"> Let's Start the <span>Conversation!</span></h2>
                  <p className="content mb-5">
                    Whether you're planning a stay, looking for information about our experiences, or interested in working with us, we'd love to hear from you. Reach out to our team - we're here to answer your questions and help you make the most of your Camp Hornbill experience.
                  </p>

                  <div className="info-item-box mb-4 d-flex align-items-start">
                    {/* <div className="icon-circle me-3">
                      <i className="bi bi-geo-alt"></i>
                    </div> */}
                    <div>
                      <h5 className="sub-heading mb-1">Our Location</h5>
                      <p className="content" style={{ fontSize: '16px' }}>Camp Hornbill
                        Village - Kyari
                        Post Office - Ramnagar
                        District - Nainital, Uttarakhand
                        244715</p>
                    </div>
                  </div>

                  <div className="info-item-box mb-4 d-flex align-items-start">
                    {/* <div className="icon-circle me-3">
                      <i className="bi bi-envelope"></i>
                    </div> */}
                    <div>
                      <h5 className="sub-heading mb-1">Email Address</h5>
                      <p className="content" style={{ fontSize: '16px' }}>info@thecamphornbill.com <br/>camphornbill@gmail.com </p>
                    </div>
                  </div>

                  <div className="info-item-box mb-4 d-flex align-items-start">
                    {/* <div className="icon-circle me-3">
                      <i className="bi bi-telephone"></i>
                    </div> */}
                    <div>
                      <h5 className="sub-heading mb-1">Phone Number</h5>
                      <p className="content" style={{ fontSize: '16px' }}>+91 8279640517, 7983397932</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side: Contact Form */}
              <div className="col-lg-7">
                <div className="bg-white p-25 rounded-3 shadow-sm">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label className="form-label sub-heading">
                          Your Name
                        </label>

                        <input
                          type="text"
                          name="name"
                          className="form-control custom-input"
                          placeholder="John Doe"
                          value={formData.name}
                          onChange={handleChange}
                        />

                        {errors.name && (
                          <small className="text-danger">
                            {errors.name}
                          </small>
                        )}
                      </div>

                      <div className="col-md-6 mb-3">
                        <label className="form-label sub-heading">
                          Email Address
                        </label>

                        <input
                          type="email"
                          name="email"
                          className="form-control custom-input"
                          placeholder="name@example.com"
                          value={formData.email}
                          onChange={handleChange}
                        />

                        {errors.email && (
                          <small className="text-danger">
                            {errors.email}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <label className="form-label sub-heading">
                        Subject
                      </label>

                      <input
                        type="text"
                        name="subject"
                        className="form-control custom-input"
                        placeholder="How can we help?"
                        value={formData.subject}
                        onChange={handleChange}
                      />

                      {errors.subject && (
                        <small className="text-danger">
                          {errors.subject}
                        </small>
                      )}
                    </div>

                    <div className="mb-4">
                      <label className="form-label sub-heading">
                        Message
                      </label>

                      <textarea
                        name="message"
                        rows="5"
                        className="form-control custom-input"
                        placeholder="Write your message here..."
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>

                      {errors.message && (
                        <small className="text-danger">
                          {errors.message}
                        </small>
                      )}
                    </div>

                    <button
                      type="submit"
                      className="primary_btn w-100 py-3"
                    >
                      Send Message
                    </button>

                    {/* Success Message */}
                    {successMessage && (
                      <div className="alert alert-success mt-3">
                        {successMessage}
                      </div>
                    )}
                  </form>
                </div>
              </div>

            </div>
          </div>
        </section>

        {/* Map Section */}
        <section className="map-section">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3477.1213046441467!2d79.19226429999999!3d29.366737199999992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390a12a2d24f8b83%3A0xa7cba4de88a324d7!2sCamp%20Hornbill%2C%20Kyari%20(Corbett)!5e0!3m2!1sen!2sin!4v1783010137113!5m2!1sen!2sin"  width="100%"
            height="450"
            style={{ border: 0, display: 'block' }} allowfullscreen="" loading="lazy" referrerpolicy="strict-origin-when-cross-origin"></iframe>
        </section>
      </div>
    </>
  )
}

export default Contact